import { createContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { getAuthDataCall2, getDataCall } from '../services/utils';
import { useNotificationRefresh } from '../../hooks/useNotificationRefresh';

import { showError } from '../Utils/helper';
import { logoutUser } from '../navigation/navbar/helper';
import { setUnreadNotificationToRead } from '../services/notifications';
import { useTranslation } from 'react-i18next';

export const UserContext = createContext();

// This context provider is passed to any component requiring the context
export const UserProvider = ({ children }) => {
    let cookie = Cookies.get('EAPISID');
    let loggedIn = cookie === undefined || cookie === null || cookie === '' ? false : cookie;
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(true);
    const [category, setCategory] = useState(null);
    const [loadingUser, setLoadingUser] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const [notifications, setNotifications] = useState(null);
    const { t } = useTranslation();

    async function userGet() {
        if (loggedIn) {
            setLoadingUser(true);
            const response = await getAuthDataCall2('/me');
            if (response.success !== true && response.status === 403) {
                Cookies.remove('EAPISID');
                Cookies.remove('auth');
                if (window.location.pathname !== '/under-verification') {
                    window.location.href = '/under-verification';
                }
            } else {
                setToken(response.success);
            }
            setUser(response.data);
            setLoadingUser(false);

            return response.data;
        }

        return null;
    }

    async function getCategory(countryId) {
        let url = `/v1/category?countryId=${countryId}`;
        const resp = await getDataCall(url);
        if (resp.success) {
            setCategory(resp.data);
        } else {
            showError(t('alertMessage.wrong'));
        }
    }

    const showAllNotitfication = async () => {
        await setUnreadNotificationToRead();
        setNotificationCount(0);
    };

    useNotificationRefresh(loggedIn, setNotificationCount, setNotifications);

    useEffect(() => {
        const initializeData = async () => {
            const fetchedUser = await userGet();
            if (fetchedUser?.country_id) {
                getCategory(fetchedUser.country_id);
            }
        };

        initializeData();
    }, []);

    useEffect(() => {
        if (!token) {
            logoutUser();
        }
    }, [token]);

    return (
        <UserContext.Provider
            value={{
                loggedIn: loggedIn,
                user: user,
                loadingUser: loadingUser,
                category: category,
                notifications: notifications,
                notificationCount: notificationCount,
                resetNotification: showAllNotitfication,
                getCategory: getCategory,
                refreshUser: userGet,
            }}
        >
            {children}
        </UserContext.Provider>
    );
};
